import transport from './transport';
import logistics from './logistics';
import finance from './finance';

const data = {
  transport,
  logistics,
  finance
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Solution/config/index.js